import _floatingForwardCommunicator from '../_internal/reducers/floatingForwardCommunicator';
export const floatingForwardCommunicator = _floatingForwardCommunicator;